export enum MailCodeOfferType {
  RATE = 'RATE',
  SAVINGS = 'SAVINGS',
}
